import { post } from '../api.service';

export const registerWithEmailAndPassword = async (user: { language: string; }) => {
    const tduid = localStorage.getItem("tduid");
    const requestBody = { ...user, tduid };

    return await post(`/signup/add?lang=${user?.language}`, requestBody);
};